import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { MapPin, Mail, Phone, Eye } from "lucide-react";
import api from "../lib/api";
import { useContent } from "../lib/content";

export default function Footer() {
  const cms = useContent();
  const [visits, setVisits] = useState(null);
  const [freePages, setFreePages] = useState([]);
  useEffect(() => {
    api.publicStats().then((s) => setVisits(s.visits_total)).catch(() => {});
    api.pages().then((r) => setFreePages(r.pages || [])).catch(() => {});
  }, []);

  return (
    <footer data-testid="main-footer" className="relative z-10 border-t border-white/10 bg-navy-surface/40">
      <div className="mx-auto max-w-7xl px-5 py-16 lg:px-8">
        <div className="grid gap-12 md:grid-cols-2 lg:grid-cols-4">
          <div>
            <Link to="/" className="flex items-center gap-2.5">
              <img src="/logo-s.png" alt="Logo Speed Détresse" className="h-9 w-9 rounded-full object-cover" />
              <span className="font-serif text-xl text-white">
                Speed <span className="text-gold">Détresse</span>
              </span>
            </Link>
            <p className="mt-4 max-w-xs text-sm leading-relaxed text-slate-400">
              {cms("site.footer.description", "La façade publique de Speed Détresse : protéger, entretenir, suivre et gérer les logements.")}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Espaces</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li><Link to="/espaces" className="hover:text-white">Propriétaire</Link></li>
              <li><Link to="/espaces" className="hover:text-white">Locataire</Link></li>
              <li><Link to="/espaces" className="hover:text-white">Airbnb</Link></li>
              <li><Link to="/espaces" className="hover:text-white">Technicien</Link></li>
              <li><Link to="/rejoindre" className="hover:text-white">Apporteur d'affaires</Link></li>
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Services</h4>
            <ul className="mt-4 space-y-2.5 text-sm text-slate-400">
              <li><Link to="/depannage" className="hover:text-white">Dépannage 7j/7</Link></li>
              <li><Link to="/solutions" className="hover:text-white">Carnet de Santé</Link></li>
              <li><Link to="/annonces" className="hover:text-white">Annonces immobilières</Link></li>
              <li><Link to="/solutions" className="hover:text-white">État des lieux intelligent</Link></li>
              <li><Link to="/tarifs" className="hover:text-white">Tarifs & calculateur</Link></li>
              <li><Link to="/metiers" className="hover:text-white">Nos métiers / corps d'état</Link></li>
              <li><Link to="/application" className="hover:text-white">Application & IA</Link></li>
              <li><Link to="/conseils" className="hover:text-white">Conseils & actualités</Link></li>
              <li><Link to="/contact" className="hover:text-white">FAQ</Link></li>
              {freePages.map((p) => (
                <li key={p.slug}><Link to={`/p/${p.slug}`} data-testid={`footer-page-${p.slug}`} className="hover:text-white">{p.title}</Link></li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-xs font-semibold uppercase tracking-[0.2em] text-gold">Contact</h4>
            <ul className="mt-4 space-y-3 text-sm text-slate-400">
              <li className="flex items-center gap-2.5"><MapPin className="h-4 w-4 text-gold" /> {cms("site.zone", "Amiens & secteur d'intervention")}</li>
              <li className="flex items-center gap-2.5"><Mail className="h-4 w-4 text-gold" /> {cms("site.email", "speeddetresse@gmail.com")}</li>
              <li className="flex items-center gap-2.5"><Phone className="h-4 w-4 text-gold" /> {cms("site.phone", "07 68 57 02 27")}</li>
            </ul>
          </div>
        </div>

        <div className="mt-14 flex flex-col items-start justify-between gap-4 border-t border-white/10 pt-6 text-xs text-slate-500 sm:flex-row sm:items-center">
          <div className="flex flex-wrap items-center gap-4">
            <p>© {new Date().getFullYear()} Speed Détresse — Site vitrine & passerelle sécurisée.</p>
            {visits !== null && (
              <span data-testid="footer-visit-counter" className="inline-flex items-center gap-1.5 rounded-full border border-gold/25 px-3 py-1 text-gold">
                <Eye className="h-3.5 w-3.5" /> {visits.toLocaleString("fr-FR")} visite{visits > 1 ? "s" : ""}
              </span>
            )}
          </div>
          <div className="flex flex-wrap gap-4">
            <Link to="/mentions-legales" className="hover:text-white">Mentions légales</Link>
            <Link to="/confidentialite" className="hover:text-white">Confidentialité</Link>
            <Link to="/cookies" className="hover:text-white">Cookies</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}
